export const SPECIALISTS_URLS = {
  realtors: '/realtors/',
  agencies: '/agentstva/',
} as const;

export const MIN_SPECIALISTS_COUNT = 2;
